

export default {

  async asyncData ({ route, error, redirect, $getPosts, $postMeta, $getRedirection }) {
    let fullPath = route.fullPath;

    // Check for player
    if (route.params.pathMatch.includes(`/player/`)) {
      const teamPath = route.params.pathMatch.split(`/player/`)[0];
      fullPath = `${teamPath}/player/`;
    }
    // Check for staff member
    if (route.params.pathMatch.includes(`/staff-member/`)) {
      const teamPath = route.params.pathMatch.split(`/staff-member/`)[0];
      fullPath = `${teamPath}/staff-member/`;
    }

    const queryParams = {
      fields: `id,title,slug,excerpt,content,image,author,date,time,categories,link,acf,type,nextprev,terms,meta,readingTime`,
      options: {
        taxonomy: `page_type`,
      },
      post_status: `publish`,
      path: fullPath,
    };

    const request = await $getPosts(`/postpath`, queryParams);
    if (request) {
      return {
        meta: $postMeta(request[0]),
        post: request[0],
      };
    }
    error({
      statusCode: 404,
      message: `This page cannot be found`,
    });
  },
  data () {
    return {
      post: {},
      flexiblePostTypes: [`page`, `post`, `partner`],
    };
  },
  computed: {
    showSidebar () {
      return this.post?.acf?.enable_sidebar || false;
    },
    showExcerpt () {
      return this.post?.acf?.show_excerpt_on_post || false;
    },
    pageBackground () {
      return this.post?.acf?.page_background?.background || `bg-grey100`;
    },
    attachedDocuments () {
      return this.post?.acf?.documents
        ? [{ documents: this.post.acf.documents }]
        : false;
    },
  },
  mounted () {
    this.setPostData(this.post);
    this.$nextTick(() => {
      const colourScheme = this.post?.acf?.use_commercial_colour_scheme;
      this.$store.dispatch(`wp/setColourScheme`, colourScheme);
      const taxonomies = this.getTaxonomies(this.post);
      this.$store.dispatch(`wp/setTaxonomies`, taxonomies);
    });
  },
  methods: {
    /**
     * @description Determines the type of dynamic content piece (post, page)
     * @param       types Array - the types this component should be used on
     * @param       post Object - the post object received from the API
     * @return      String - the type of post
     */
    isContentType (types = [], post = false) {
      // Determine type by post type or page type (this helps cover variety of content page types (default, accordion, etc.))
      let type = post.type;
      if (this.isTypeOverride(types, post.type)) {
        return true;
      }
      if (this.flexiblePostTypes.includes(type) && post.terms.length) {
        const term = post.terms.find(term => term.taxonomy === `page_type`);
        type = term ? term.slug : post.type;
      }
      if (types.includes(type)) {
        return true;
      }
      return false;
    },
    isTypeOverride (types, type) {
      const overrides = [`post`, `report`, `live`, `match_preview`];
      if (overrides.includes(type) && types.some(type => overrides.includes(type))) {
        return true;
      }
    },
  },
  head () {
    return {
      title: `${process.env.siteTitle} - ${this.post.title}`,
      description: this.post.yoast ? this.post.yoast.description : this.post.excerpt,
      meta: this.meta,
      link: [
        {
          rel: `canonical`,
          href: `${process.env.desiredCanonical}${this.$route.path}`,
        },
      ],
    };
  },
};
